module.exports = __webpack_public_path__ + "static/img/cont51 (1).11a18bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont51 (1).jpg
// module id = R0s6
// module chunks = 0